import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=0b8b78a0&scoped=true"
import script from "./AboutMe.vue?vue&type=script&lang=ts"
export * from "./AboutMe.vue?vue&type=script&lang=ts"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=0b8b78a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b78a0",
  null
  
)

export default component.exports